// Mode cetak BAWAAN per dokumen (mig 7400, permintaan pemilik 2026-10-14):
// tombol "Cetak Surat Jalan" / "Cetak Tagihan" memakai Printer Biasa (A4/A5)
// atau Printer Thermal (struk 58/80 mm). Disimpan di `site_settings`
// (`print_mode_invoice` / `print_mode_packing_list`, siteSettings.ts) — tanpa
// DDL. Absen/tak dikenal = 'regular', persis perilaku sebelum struk thermal
// ada, jadi toko yang tak menyentuh setelan ini mencetak dokumen yang sama.
//
// Modul murni tanpa impor supaya siteSettings.ts (dibaca hampir semua layar)
// tak menyeret registri cetak ke chunk-nya.

/** Format cetak: `regular` = Printer Biasa (PDF A4 / surat jalan A5-A4), `thermal` = struk 58/80 mm. */
export type PrintMode = "regular" | "thermal";

/** Dokumen yang punya dua format cetak — kuncinya = kunci grup `/admin/settings/print?jenis=`. */
export type PrintModeDoc = "invoice" | "packing_list";

export const PRINT_MODE_DOCS: readonly PrintModeDoc[] = ["invoice", "packing_list"] as const;

/** Nilai mentah → mode; hanya 'thermal' eksplisit yang thermal. */
export function coercePrintMode(raw: string | null | undefined): PrintMode {
  return (raw ?? "").trim().toLowerCase() === "thermal" ? "thermal" : "regular";
}

/** Label pilihan format di layar setelan & saklar cetak. */
export function printModeLabel(mode: PrintMode): string {
  return mode === "thermal" ? "Printer Thermal" : "Printer Biasa";
}
